export default "__VITE_ASSET__i$rwBgif__"